import type { ChurchService } from "../../model/launchpad";
import { useNavigate } from "react-router";
import { serviceDetailPath } from "../../routes";
import ChurchServiceCard from "./ChurchServiceCard";
import { useDiscussionQuestions } from "./DiscussionQuestionsProvider";

// Web port of FeaturedServiceView
// (HomeFeature/View/Component/FeaturedServiceView.swift).
//
// Mirrors the app's split: this layer knows the model, ChurchServiceCard stays
// presentational and takes flattened values.

export interface FeaturedServiceCardProps {
  service: ChurchService;
  /**
   * Overrides the default. Left unset, the button presents the discussion
   * questions sheet, the way FeaturedServiceView does in the app.
   */
  onDiscussionQuestionsClick?: (service: ChurchService) => void;
  /**
   * Overrides the default. Left unset, the card and its Details button open
   * the service detail page, the way FeaturedServiceView navigates in the app.
   */
  onDetailsClick?: (service: ChurchService) => void;
}

export default function FeaturedServiceCard(props: FeaturedServiceCardProps) {
  const { attributes } = props.service;
  const presentQuestions = useDiscussionQuestions();
  const navigate = useNavigate();

  const handleDetails = () => {
    if (props.onDetailsClick) {
      props.onDetailsClick(props.service);
      return;
    }

    navigate(serviceDetailPath(props.service));
  };

  const handleDiscussionQuestions = () => {
    if (props.onDiscussionQuestionsClick) {
      props.onDiscussionQuestionsClick(props.service);
      return;
    }

    presentQuestions?.({
      title: attributes.title,
      content: attributes.discussionQuestions ?? "",
    });
  };

  return <ChurchServiceCard
    thumbnailUrl={attributes.thumbnailURL}
    title={attributes.title}
    description={attributes.description}
    discussionQuestions={attributes.discussionQuestions}
    onDiscussionQuestionsClick={handleDiscussionQuestions}
    onDetailsClick={handleDetails}
  />
}
